import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {AIConditionSignal} from '../../promptToCardAgentV2.types';
import getCardFromState from '../../utils/cardStateStorage/getCardFromState';
import setCardInState from '../../utils/cardStateStorage/setCardInState';
import {ConditionOperatorKey} from 'common/src/modules/conditions/conditions.types';

const setSignalInputSchema = z.object({
  signal: z.custom<Omit<AIConditionSignal, 'optionalOperators'>>().describe('The signal to set'),
  operator: z.nativeEnum(ConditionOperatorKey).describe('The operator to set for the signal'),
});

export default function setSignalTool() {
  async function execute(params: ToolExecuteParams<typeof setSignalInputSchema>) {
    const {signal, operator} = params.input;

    const card = getCardFromState();
    card.condKey = signal.signalKey;
    card.condKeyType = signal.signalType;
    card.condOperator = operator;
    card.categories = signal.categories.map((category) => category.value);
    card.signalDescription = signal.signalName;
    setCardInState(card);

    return toolResult(`Signal set successfully: ${JSON.stringify(signal)}`);
  }

  return tool({
    name: V2CardAgentToolName.SetSignal,
    displayName: 'Setting signal',
    description:
      "Following the user's prompt, set the signal for the condition card. Use the values returned from the ${CampaignSetupAgentToolName.SearchSignal} tool to set the signal for the condition card. Match the signal and operator to the user's prompt.",
    inputSchema: setSignalInputSchema,
    execute,
  });
}
